<template>
  <div class="news-page">
    <img src="@/assets/images/medias/media-banner.png" class="banner" alt="">
    <div class="content">
      <div class="news-list list">

        <div class="list-title">公司新闻</div>
        <router-link :to="{path:'news-detail',query:{id:item.id}}" v-for="(item,index) in list" :key="index">
          <div class="list-item">
            <img class="list-image" :src="item.url" alt="">
            <div class="list-meta">
              <div class="meta-title">{{ item.title }}</div>
              <div class="meta-date">{{ item.createAt }}</div>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "news",
  data() {
    return {
      list: [],
    }
  },
  created() {
    this.initData();
  },
  methods:{
    async initData() {

        let contents = await this.$getContents(this.$channels.news);
        console.log("data.contents", contents)

        contents.forEach(
            item => {
                this.list.push({
                    id: item.id,
                    title: item.title,
                    url: process.env.VUE_APP_BASE_API + item.imageUrl,
                    createAt: item.addDate.substring(0, 10),
                    detail: item.body.replaceAll("/upload/images", process.env.VUE_APP_BASE_API + "/upload/images"),
                    from: item.source
                })
            }
        );

        this.list = this.list.sort(this.sortUpDate);
        console.log("this.list", this.list)
    },
    sortUpDate(pre,next){
      return Date.parse(next.createAt)- Date.parse(pre.createAt) ;
    }
  }
}
</script>

<style scoped>
.banner {
  width: 100%;
}

.content {
  padding: 100px 48px 137px 48px;
}

.list .list-title {
  height: 68px;
  font-size: 48px;
  font-weight: 500;
  line-height: 68px;
  padding-bottom: 10px;
}

.list-item {
  display: flex;
  height: 154px;
  margin-top: 32px;
}

.list-image {
  width: 206px;
  height: 154px;
}

.list-meta {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 24px;
}
.meta-title{
  width: 100%;
  height: 96px;
  font-size: 28px;
  font-weight: 400;
  color: #333333;
  line-height: 48px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.meta-date{
  height: 36px;
  font-size: 24px;
  font-weight: 400;
  color: #979797;
  line-height: 36px;
}

</style>
